import StringListResultModel from '../../generated/types/model/resource/StringListResultModel';

export default class StringListResultViewModel extends StringListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
